"use client";
import Lottie from "react-lottie";
import lottieSiteLoader from "utils/lottie/happy.json";

const loaderLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: lottieSiteLoader,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

interface IAiRobot {
  size: number;
  height?: number;
}

const AiRobot = (props: IAiRobot) => {
  const { size, height } = props;

  return (
    <Lottie
      isClickToPauseDisabled
      options={loaderLottieOptions}
      height={height || size}
      width={size}
    />
  );
};

export default AiRobot;
